import React from "react"
import { ListGroup } from "react-bootstrap"
import { ReportAPI } from "../../lib/utils"
import ReportLinkItem from "./ReportLinkItem"

export default function AccountingReportLinks({ api }) {

  return (
    <ListGroup>

      <ReportLinkItem url='/reports/general-ledger-report' title='General Ledger Report'
        disabled={ api === ReportAPI.GENERAL_LEDGER } />

      <ReportLinkItem url='/reports/income-statement' title='Income Statement'
        disabled={ api === ReportAPI.INCOME_STATEMENT } />

      <ReportLinkItem url='/reports/balance-sheet' title='Balance Sheet'
        disabled={ api === ReportAPI.BALANCE_SHEET } />

      <ReportLinkItem url='/reports/trial-balance' title='Trial Balance'
        disabled={ api === ReportAPI.TRIAL_BALANCE } />
    </ListGroup>
  )
}



// WEBPACK FOOTER //
// ./src/components/Reports/AccountingReportLinks.js